import {SimilarToClickListingsServiceQuery} from "../../serp/services/SimilarToClickListingsServiceQuery";

export interface ListingsRepository {
    getSimilarToClickListings(query: SimilarToClickListingsServiceQuery): Promise<string>;
}

export class ApiListingsRepository implements ListingsRepository {
    public async getSimilarToClickListings(query: SimilarToClickListingsServiceQuery): Promise<string> {
        const apiUrl = this.buildApiUrlWithQueryParams(`/api/serp/listings/${query.listingId}/similar`);
        return fetch(apiUrl.toString(), {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                geoId: query.geoId,
                operationType: query.operationType,
                bedrooms: query.bedrooms,
                bathrooms: query.bathrooms,
                price: query.price,
                pageViewId: query.pageViewId,
                excludeListings: query.excludeListings,
            }),
        }).then((response) => response.text());
    }

    private buildApiUrlWithQueryParams(baseURL: string): URL {
        const currentUrl = new URL(window.location.href);
        const queryParams = currentUrl.searchParams;
        const apiUrl = new URL(baseURL, window.location.origin);
        queryParams.forEach((value, key) => {
            apiUrl.searchParams.append(key, value);
        });
        return apiUrl;
    }
}
